import _ from 'lodash';
import Vue from 'vue';
import {
    GET_PREDICT_LIST_REQUEST,
    GET_PREDICT_LIST_SUCCESS,
    GET_PREDICT_LIST_FAILURE,
    RESOLVE_PREDICT_LIST_PARAMS,
    UPDATE_PREDICT_LIST_CONFIG,
    UPDATE_PREDICT_LIST_DATA,
    GET_PREDICT_GOODS_INFO_REQUEST,
    GET_PREDICT_GOODS_INFO_SUCCESS,
    GET_PREDICT_GOODS_INFO_FAILURE,
    GET_PROXY_DETAIL_REQUEST,
    GET_PROXY_DETAIL_SUCCESS,
    GET_PROXY_DETAIL_FAILURE,
    RESET_PREDICT_PAGE_DATA
} from '../mutationTypes';

const state = {
    listLoading: false,
    list: [],
    mobile: '',
    carNo: '',
    name: '',
    page: 1,
    pageSize: 20,
    pageCount: 0,
    listParams: {},
    goodsDetail: null,
    goodsLoading: false,
    predictPromot: null,
    promotLoading: false,
    proxyDetail: null,
    proxyLoading: false,
    goodsState: 1,
    marketingState: 1
};
const mutations = {
    [GET_PREDICT_LIST_REQUEST](state) {
        state.listLoading = true;
    },
    [GET_PREDICT_LIST_SUCCESS](state, res) {
        state.listLoading = false;

        const { data, page_count: pageCount } = res;

        state.pageCount = pageCount;
        state.list = data;
    },
    [GET_PREDICT_LIST_FAILURE](state) {
        state.listLoading = false;
    },
    [UPDATE_PREDICT_LIST_CONFIG](state, config) {
        const { name, carNo, mobile, page, goodsState, marketingState } = config;
        if (name || name === '') state.name = name;
        if (carNo || carNo === '') state.carNo = carNo;
        if (mobile || mobile === '') state.mobile = mobile;
        if (goodsState || goodsState === '') state.goodsState = goodsState;
        if (marketingState || marketingState === '') state.marketingState = marketingState;
        if (page) {
            state.page = page;
            state.listParams.page = page;
        }
    },
    [RESOLVE_PREDICT_LIST_PARAMS](state, params) {
        state.listParams = params;
    },
    [GET_PREDICT_GOODS_INFO_REQUEST](state) {
        state.goodsLoading = true;
    },
    [GET_PREDICT_GOODS_INFO_SUCCESS](state, res) {
        state.goodsLoading = false;
        state.goodsDetail = res;
    },
    [GET_PREDICT_GOODS_INFO_FAILURE](state) {
        state.goodsLoading = false;
    },
    [GET_PROXY_DETAIL_REQUEST](state) {
        state.proxyLoading = true;
    },
    [GET_PROXY_DETAIL_SUCCESS](state, res) {
        state.proxyLoading = false;

        state.proxyDetail = res;
    },
    [GET_PROXY_DETAIL_FAILURE](state) {
        state.proxyLoading = false;
    },
    [UPDATE_PREDICT_LIST_DATA](state, predictedId) {
        if (!predictedId) return;
        const index = _.findIndex(state.list,
            item => predictedId === item.predicted_id
        );
        if (index >= 0) state.list[index].is_promoted = '1';
    },
    [RESET_PREDICT_PAGE_DATA](state) {
        _.extend(state, _.cloneDeep({
            listLoading: false,
            list: [],
            mobile: '',
            carNo: '',
            name: '',
            page: 1,
            goodsState: 1,
            marketingState: 1,
            pageSize: 20,
            listParams: {},
            goodsDetail: null,
            goodsLoading: false,
            predictPromot: null,
            promotLoading: false,
            proxyDetail: null,
            proxyLoading: false,
        }));
    }
};

export const actions = {
    async getPredictList({ commit }) {
        commit(GET_PREDICT_LIST_REQUEST);

        const res = await Vue.$ajax.get('predictList', state.listParams);

        if (!res.errorType) {
            commit(GET_PREDICT_LIST_SUCCESS, res);
        } else {
            commit(GET_PREDICT_LIST_FAILURE);
        }
    },
    updatePredictConfig({ commit }, config) {
        commit(UPDATE_PREDICT_LIST_CONFIG, config);
    },
    updatePredictListData({ commit }, predictedId) {
        commit(UPDATE_PREDICT_LIST_DATA, predictedId);
    },
    resolvePredictListParams({ commit }) {
        const {
            page, name, mobile,
            carNo, pageSize,
            goodsState, marketingState
        } = state;

        commit(RESOLVE_PREDICT_LIST_PARAMS, {
            name,
            page,
            mobile,
            car_no: carNo,
            pagesize: pageSize,
            goodsStatus: goodsState,
            marketingStatus: marketingState,
        });
    },
    async getPredictGoodsInfo({ commit }, predictId) {
        commit(GET_PREDICT_GOODS_INFO_REQUEST);

        const res = await Vue.$ajax.get('predictMsg', {
            predicted_id: predictId
        });

        if (!res.errorType) {
            commit(GET_PREDICT_GOODS_INFO_SUCCESS, res);
        } else {
            commit(GET_PREDICT_GOODS_INFO_FAILURE);
        }
    },
    async getProxyGoodsDetail({ commit }, params) {
        commit(GET_PROXY_DETAIL_REQUEST);

        const res = await Vue.$ajax.get('getAgentGoodsDetail', params);

        if (!res.errorType) {
            commit(GET_PROXY_DETAIL_SUCCESS, res);
        } else {
            commit(GET_PROXY_DETAIL_FAILURE);
        }
    },
    resetPredictPageData({ commit }) {
        commit(RESET_PREDICT_PAGE_DATA);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/predict.js